import React from "react";

const steps = [
    {
        num: 1,
        title: "Диагностический этап",
        desc: "Установление контакта, уточнение запроса, первичная диагностика.",
    },
    {
        num: 2,
        title: "Этап концептуализации",
        desc: "Формулирование психотерапевтической гипотезы, определение мишеней работы.",
    },
    {
        num: 3,
        title: "Этап интервенции",
        desc: "Выстраивание пошаговой тактики терапии с обратной связью. Работа над запросом с применением конкретных техник/протоколов. Получение доступа к проблемной зоне внутри психики.",
    },
    {
        num: 4,
        title: "Этап интеграции",
        desc: "Закрепление новых навыков и паттернов поведения. Оптимизация работы психики, увеличение адаптационных способностей человека. Профилактика рецидивов.",
    },
];

export const ProcessSection = () => {
    const TIMELINE_WIDTH = "w-[2px]";
    const TEXT_PADDING_LEFT = "pl-12 sm:pl-16";

    return (
        <section id="process" className="py-16 relative overflow-hidden">
            <div
                className="absolute left-0 overflow-hidden top-[10%] w-[30vh] ml-[5vw] h-[80%] bg-no-repeat bg-bottom bg-contain pointer-events-none"
                style={{ backgroundImage: "url('/image/svg/loza.svg')" }}
            />

            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-5">
                <h2 className="font-serif pt-12 text-3xl text-olive-950 text-center">
                    Процесс терапевтической работы
                </h2>

                <div className="relative items-start space-y-12 mt-12">
                    {/* Вертикальная линия */}
                    <div
                        className={`absolute left-4 -translate-x-1/2 top-0 bottom-0 w-px bg-olive-200 ${TIMELINE_WIDTH}`}
                    />

                    {steps.map((step) => (
                        <div key={step.num} className="w-full  items-center relative">
                            <div className="absolute left-4 -translate-x-1/2">
                                <div className="w-8 h-8 sm:w-12 sm:h-12 bg-olive-50 rounded-full grid place-items-center text-lg sm:text-xl font-serif font-semibold text-olive-950 shadow-md ring-4 ring-white">
                                    {step.num}
                                </div>
                            </div>

                            <div className={`${TEXT_PADDING_LEFT}`}>
                                <h3 className="font-serif font-semibold leading-none tracking-tight text-olive-950">
                                    {step.title}
                                </h3>
                                <p className="mt-1 text-olive-900/80 text-sm">{step.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
